import { createSlice } from "@reduxjs/toolkit";
import {
  getAllSnapShots,
  getFerrumTokenValue,
} from "../../_apis/LeaderboardCrud";

const initialState = {
  isLoading: false,
  error: false,
  leaderboardList: [],
  frmUsdcValue: "",
  frmxUsdcValue: "",
  leaderboardInformation: [],
};

const slice = createSlice({
  name: "leaderboard",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getLeaderboardListSuccess(state, action) {
      state.isLoading = false;
      state.leaderboardList = action.payload;
    },

    getFRMTokenValueSuccess(state, action) {
      state.isLoading = false;
      state.frmUsdcValue = action.payload;
    },

    getFRMXTokenValueSuccess(state, action) {
      state.isLoading = false;
      state.frmxUsdcValue = action.payload;
    },
    getLeaderboardInformation(state, action) {
      state.isLoading = false;
      state.leaderboardInformation = action.payload;
    },
  },
});

export default slice.reducer;
let tokenPrice = "";
export const getFrmValue = (id) => {
  getFerrumTokenValue(id)
    .then((res) => {
      const price = res.data["ferrum-network"].usd;
      tokenPrice = price;
    })
    .catch((e) => {
      console.log(e);
    });
};
export const getSnapHodlData = (snapHodlId) => async (dispatch) => {
  dispatch(slice.actions.startLoading());
  getAllSnapShots(snapHodlId)
    .then((res) => {
      if (res?.data.length) {
        let data = res?.data;
        data.length = 1;
        data.forEach((entry, index) => {
          const walletId = Object.keys(entry.totalStakedBalance);
          const walletBalance = Object.values(entry.totalStakedBalance);
          const max = Math.max(...walletBalance);
          if (walletBalance && walletId) {
            let response = walletId.map((value, index) => {
              return {
                wallet: value,
                usd: tokenPrice * walletBalance[index],
                balance: walletBalance[index],
                levelUpAmount: max,
              };
            });
            response.sort(
              (a, b) => parseFloat(b.balance) - parseFloat(a.balance)
            );
            response.forEach((item, index) => {
              item.rank = index + 1;
            });

            let reSortedArray = response.map((item) => {
              return {
                rank: item.rank,
                wallet: item.wallet,
                usd: item.usd,
                balance: item.balance,
                levelUpAmount: item.levelUpAmount,
              };
            });
            dispatch(slice.actions.getLeaderboardInformation(reSortedArray));
          }
        });
      }
    })
    .catch((error) => {
      dispatch(slice.actions.hasError(error));
    });
};
